import { IconButton } from '@mui/material';
import { ReactComponent as WhatsappIcon } from '../img/whatsapp.svg';

export default function WhatsappContact() {
  
  const handleWhatsapp = () => {
      let mobileNumber = encodeURIComponent("+6591521378")
      window.open(`https://api.whatsapp.com/send?phone=${mobileNumber}`)
  }

  return (
    <IconButton onClick={handleWhatsapp}><WhatsappIcon style={{width:"40px"}}/></IconButton>
  )
}
